type AuditActor = { id?: number; name?: string; role?: string };

let actor: AuditActor | null = null;

export function setAuditActor(next: AuditActor | null): void {
  actor = next;
}

export function getAuditActor(): AuditActor | null {
  return actor;
}
